import {ListBase, ListProps, useListContext} from "react-admin";
import {Card, Table, Input, Button, Row, Col} from 'antd';

const { Search } = Input;
import React, {useEffect, useState} from "react";
import SkeletonTable, { SkeletonTableColumnsType } from "../Common/SkeletonTable";
import {Link, useLocation} from "react-router-dom";
import { getTagForChangeState } from "../Common/Tags";
import { formatDateAndTime } from "../../helpers/utils";
import SubmissionExpandedRow from "./SubmissionExpandedRow";
import LazyExpandedRow from "../Common/LazyExpandedRow";
import {onExpandOnlyOneRow} from "../Common/tableUtils";
import {renderCommitID} from "./SubComponents/CommitID";


const ListView = (props: ListProps) => {
    const { ids, data, loading, filterValues, setFilters, page, total, perPage, setPage, setPerPage } = useListContext();
    const [expandedRowKeys, setExpandedRowKeys] = useState<number[]>([])

    const location = useLocation();
    useEffect(() => {
        setExpandedRowKeys([Number(location.hash.substring(1))])
    }, [location]);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Commit ID',
            dataIndex: 'commit_id',
            key: 'commit_id',
            render: (text: any) => renderCommitID(text)
        },
        {
            title: 'Change State',
            key: 'change_state',
            render: (text: any, record: any) => (
                <Link to={`/change_instances?filter={"commit_id":"${record.commit_id}"}`} >
                    <span className='service-item-card-text link'>{getTagForChangeState(record.change_state)}</span>
                </Link>
            )
        },
        {
            title: 'Created',
            key: 'created',
            render: (text: any, record: any) => formatDateAndTime(record.created)
        },
        {
            render: (record: any) => <Link to={"/submissions/"+record.id}><Button>Details</Button></Link>
        },
    ];

    const setFilterCommitId = (value: string) => {
        setFilters({ ...filterValues, 'commit_id': value }, {})
    }

    const tableData: Array<Object> = [];
    data && ids.forEach(id => tableData.push(data[id]));
    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
        >
            <Row gutter={[8, 0]} style={{padding: '16px',}}>
                <Col span={8}>
                    <Search
                        className='item-search'
                        style={{ borderRadius: '8px', overflow: 'hidden' }}
                        allowClear
                        placeholder="Search by commit id"
                        onSearch={setFilterCommitId}
                        enterButton
                    />
                </Col>
            </Row>
            <SkeletonTable loading={loading} columns={columns as SkeletonTableColumnsType[]}>
                <Table
                    pagination={{
                        total: total,
                        pageSize: perPage,
                        pageSizeOptions: [25, 50, 100],
                        onShowSizeChange: (_current, size) => setPerPage(size), showSizeChanger: true,
                        current: page,
                        onChange: page => setPage(page),
                        className: "pagination-padding",
                    }}
                    rowKey="id"
                    columns={columns}
                    dataSource={tableData}
                    expandable={{
                        expandedRowRender: (record) => <LazyExpandedRow lightRecord={record} resource={"submissions"} ExpandedRowComponent={SubmissionExpandedRow}/>,
                        expandRowByClick: true,
                        expandedRowKeys: expandedRowKeys,
                        onExpand: onExpandOnlyOneRow(setExpandedRowKeys)
                    }}
                />
            </SkeletonTable>
        </Card>
    )
}

const SubmissionsList = (props: ListProps) => (
    <ListBase
        filter={{light: true}}
        sort={{ field: 'id', order: 'DESC' }}
        perPage={25}
        {...props}
    >
        <ListView />
    </ListBase>
)

export default SubmissionsList;
